<div class="chatDiv">
    <div #scrollMe style="overflow: scroll; height: 400px;">
        <div class=""
             *ngFor="let msg of messageBuffer">
            <mat-card class="example-card">
                <mat-card-header>
                    <div mat-card-avatar [ngStyle]="{'background-image': 'url(' + msg.user_avatar + ')'}"
                         class="example-header-image"></div>
                    <mat-card-title>{{msg.sent_by}}</mat-card-title>
                    <mat-card-subtitle>{{msg.created}}</mat-card-subtitle>
                </mat-card-header>
                <mat-card-content>
                    <table>
                        <tr>
                            <td>
                                {{msg.room_id}}
                            </td>
                            <td>
                                {{msg.msg}}
                            </td>
                        </tr>
                    </table>
                    <!--<p>-->
                        <!--{{msg.msg}}-->
                    <!--</p>-->
                </mat-card-content>
            </mat-card>
        </div>
    </div>


    <!--<div class="" id="chatform">-->
        <!--<form [formGroup]="chatFormGroup" novalidate (ngSubmit)="writeChatMessage()">-->
            <!--<mat-card-content>-->
                <!--<mat-form-field appearance="legacy">-->
                    <!--<input-->
                            <!--matInput-->
                            <!--autocomplete="off"-->
                            <!--name="msg"-->
                            <!--id="msg"-->
                            <!--placeholder="Was hast du zu sagen?"-->
                            <!--formControlName="msg"-->
                            <!--color="primary">-->
                    <!--<mat-icon matSuffix>send</mat-icon>-->
                    <!--<mat-hint>Beachte bitte unsere Chat Richtlinien</mat-hint>-->
                <!--</mat-form-field>-->
            <!--</mat-card-content>-->
        <!--</form>-->
    <!--</div>-->

    <div class="chatDiv">

        <div class="" id="chatRoomform">
            <form [formGroup]="chatRoomJoinFormGroup" novalidate (ngSubmit)="joinChatRoom()">
                <mat-card-content>
                    <mat-form-field appearance="legacy">
                        <input
                                matInput
                                autocomplete="off"
                                name="roomId"
                                id="joinRoomId"
                                placeholder="room id to join goes here"
                                formControlName="roomId"
                                color="primary">
                        <mat-icon matSuffix>send</mat-icon>
                    </mat-form-field>
                </mat-card-content>
            </form>
            <form [formGroup]="chatRoomLeaveFormGroup" novalidate (ngSubmit)="leaveChatRoom()">
                <mat-card-content>
                    <mat-form-field appearance="legacy">
                        <input
                                matInput
                                autocomplete="off"
                                name="roomId"
                                id="leaveRoomId"
                                placeholder="room id to leave goes here"
                                formControlName="roomId"
                                color="primary">
                        <mat-icon matSuffix>send</mat-icon>
                    </mat-form-field>
                </mat-card-content>
            </form>
            <form [formGroup]="chatFormGroup" novalidate (ngSubmit)="writeChatMessage()">
                <mat-card-content>
                    <mat-form-field appearance="legacy">
                        <input
                                matInput
                                autocomplete="off"
                                name="msg"
                                id="msg"
                                placeholder="chat message goes here"
                                formControlName="msg"
                                color="primary">
                        <mat-icon matSuffix>send</mat-icon>
                    </mat-form-field>
                </mat-card-content>
            </form>
        </div>
    </div>

</div>

